module.exports = __webpack_public_path__ + "static/logo-rmit-link-2x-21583eac59ca03f978e8923e9d0fea48.png";